import { useField } from 'formik';
import { useState } from 'react';

interface Props {
  label: string;
  name: string;
  placeholder?: string;
  showToggle?: boolean;
  type?: 'text' | 'password';
  forgotPassword?: boolean;
  error?: string;
}

export default function Input({
  label,
  placeholder,
  name,
  type,
  forgotPassword=false,
  showToggle=false,
  error,
}: Props) {

  const [toggleType, setToggleType] = useState(type);
  const [field, ea] = useField({ name, type: toggleType || 'text' });
  const errorClass = error && ea.touched ? '!border-red-500 !ring-red focus:!ring-red-500' : ''

  return (
    <div className="flex flex-col space-y-2 mb-[24px]">
      <label htmlFor={name}>
        {label}
      </label>
      <input
        {...field}
        type={toggleType || 'text'}
        className={'w-full h-12 px-4 !mb-0 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-black !bg-white !text-[16px] text-[#474747] '+ errorClass}
        placeholder={placeholder}
      />
      {showToggle && <div className='relative flex flex-row pr-3  justify-end'><span
        className='top-[-32px] cursor-pointer absolute text-[#474747] text-[12px]'
        onClick={() => setToggleType(toggleType === 'password' ? 'text' : 'password')}>
        {toggleType === 'password' ? 'Show' : 'Hide'}
      </span></div>}
      {error && ea.touched && <div className="text-red-500 text-sm">{error}</div>}
      {forgotPassword && <a href="/ap/forgot-password" className="text-[#FF609E] text-[14px] !underline">Forgot your password?</a>}

    </div>
  )

}
